export default function projectLength(data, position) {
    if (data && position)
        return data?.filter((project) => project.position === position)?.length;
}
